module.exports = __webpack_public_path__ + "img/bblogo.94bf47e3.png";